<template>
    <div>
        <el-card shadow="never" v-loading="loading">
            <el-collapse>
                <el-collapse-item v-for="(item, index) in data" :key="index" :title="item.title">
                    <div v-html="item.content"></div>
                </el-collapse-item>
            </el-collapse>
        </el-card>
    </div>
</template>

<script>
    export default {
        name: "Help",
        data () {
            return {
                data: []
            };
        },
        created () {
            this.fetchData()
        },
        methods: {
            fetchData () {
                this.loading = true;
                this.$axios.get('/faq').then((res) => {
                    this.data = res.data;
                    this.loading = false;
                })
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>